import { useLayoutEffect, useRef } from 'react';
import ActiveAdminMessage from '../../admin-message/active-admin-message/ActiveAdminMessage';
import { useAuth } from '../../auth/auth-provider/auth-provider';
import ActiveUsersCount from '../../components/active-users-count/ActiveUsersCount';
import AdminCommunicationWithServer from '../../communication-with-server/admin-communication-with-server/AdminCommunicationWithServer';
import UserCommunicationWithServer from '../../communication-with-server/user-communication-with-server/UserCommunicationWithServer';
import { useSiteSettingsStore } from '../../stores/siteSettingsStore';
import './sticky-footer.css';

const DEFAULT_TITLE = process.env.REACT_APP_DEFAULT_TITLE;

export default function StickyFooter() {
    const footerRef = useRef(null);
    const spacerRef = useRef(null);

    useLayoutEffect(() => {
        const footer = footerRef.current;
        const updateSpace = () => {
            spacerRef.current.style.height = `${footer.getBoundingClientRect().height}px`;
        };
        updateSpace();
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateSpace);
        observer?.observe(footer);
        window.addEventListener('resize', updateSpace);
        return () => {
            observer?.disconnect();
            window.removeEventListener('resize', updateSpace);
        };
    }, []);

    const auth = useAuth();
    const siteSettings = useSiteSettingsStore(state => state.siteSettings);
    const isAdmin = auth?.user?.isAdmin === true;

    return (
        <>
            <div ref={spacerRef} className="sticky-footer__spacer" aria-hidden="true" />
            <footer ref={footerRef} className="sticky-footer user-select-none">
                <div className="sticky-footer__messages">
                    <ActiveAdminMessage />
                </div>
                <div className={`sticky-footer__row${isAdmin ? "" : " sticky-footer__row--customer"}`}>
                    {isAdmin && (
                        <div className="sticky-footer__users"><ActiveUsersCount /></div>
                    )}
                    <div className="sticky-footer__site">
                        {siteSettings?.siteName || DEFAULT_TITLE}
                    </div>
                    {isAdmin ? <AdminCommunicationWithServer /> : <UserCommunicationWithServer />}
                </div>
            </footer>
        </>
    );
}
